import { useState } from 'react';
import type { FeedbackType } from '../types/feedbackType.types';

interface FeedbackTypeModalState {
  feedbackType: FeedbackType | null;
}

export function useFeedbackTypeActionModals() {
  const [modalState, setModalState] = useState<FeedbackTypeModalState | null>(null);
  const [feedbackTypeToDelete, setFeedbackTypeToDelete] = useState<FeedbackType | null>(null);

  return {
    modalState,
    feedbackTypeToDelete,
    openCreateModal: () => setModalState({ feedbackType: null }),
    openEditModal: (feedbackType: FeedbackType) => setModalState({ feedbackType }),
    closeModal: () => setModalState(null),
    openDeleteModal: setFeedbackTypeToDelete,
    closeDeleteModal: () => setFeedbackTypeToDelete(null),
  };
}
